<template>
  <advanced-table
    :headers="headers"
    :filters="filters"
    :sortBy="['dueDate']"
    :sortDesc="[true]"
    :resource="resource"
    :optionLists="optionLists"
  />
</template>

<script>
import AdvancedTable from "@/components/AdvancedTable.vue";
import { format } from "date-fns";

export default {
  data() {
    return {
      headers: [
        {
          text: "סוג",
          value: null,
          align: "start",
          visible: true,
          width: 50,
          sortable: false,
          type: "ICON",
          getIcon: (data) => {
            let taskType = this.entityById(
              "taskTypes",
              data.type ? data.type._id || data.type : null
            );
            return taskType
              ? { icon: taskType.icon, color: taskType.color }
              : {};
          },
          linkTo: item => {
            return `/tasks/${item._id}`;
          }
        },
        {
          text: "שם",
          value: "type",
          align: "start",
          visible: true,
          width: "250",
          displayFunc: (data, key) => {
            let taskType = this.entityById(
              "taskTypes",
              data[key] ? data[key]._id || data[key] : null
            );
            return taskType ? taskType.title : "לא ידוע";
          },
          linkTo: item => {
            return `/tasks/${item._id}`;
          }
        },
        {
          text: "הזמנה",
          value: "order",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            let order = this.$store.state.entities.orders[data[key]];
            if (order) {
              let traveler = this.$store.state.entities.customers[order.traveler];
              if (traveler) {
                return `${order._id} (${traveler.name})`;
              }
              return order._id;
            }
            return 'ללא הזמנה'
          },
          linkTo: item => {
            let order = this.$store.state.entities.orders[item.order];
            if (order && order._id) {
              return `/orders/${order._id}`;
            } else {
              return '';
            }
          }
        },
        {
          text: "תאריך יצירה",
          value: "created",
          align: "start",
          visible: false,
          displayFunc: (data, key) => {
            return format(data[key], "DD-MM-YYYY");
          }
        },
        {
          text: "תאריך לביצוע",
          value: "dueDate",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            let date = new Date(data[key]);
            let options = { weekday: "long", month: "long", day: "numeric" };
            return new Intl.DateTimeFormat("he-IL", options).format(date);
          }
        },
        {
          text: "תאריך ביצוע",
          value: "completionDate",
          align: "start",
          visible: false,
          displayFunc: (data, key) => {
            return data[key] ? format(data[key], "DD-MM-YYYY") : "לא בוצעה";
          }
        },
        {
          text: "בוצעה ע״י",
          value: "completedBy",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            let userId = data[key];
            if (userId) {
              let user = this.$store.state.entities.users[userId];
              return user.name;
            } else {
              return "לא בוצעה";
            }
          }
        },
        {
          text: "עריכה מהירה",
          type: "ACTION",
          value: "action",
          name: "quickEdit",
          align: "start",
          visible: true,
          icon: "mdi-pencil",
          click: taskId => {
            console.log(taskId);
            let task = this.$store.state.entities.tasks[taskId];
            console.log(task);
            if (task) {
              this.editTask(task);
            }
            return Promise.resolve();
          }
        }
      ],
      filters: [
        {
          type: "COMBOBOX",
          label: "סוג",
          model: "types",
          items: "types",
          itemText: "title",
          itemValue: "_id",
          active: true
        },
        {
          type: "DATE",
          label: "נוצר אחרי",
          model: "createdAfter",
          active: false
        },
        {
          type: "DATE",
          label: "נוצר לפני",
          model: "createdBefore",
          active: false
        },
        {
          type: "DATE",
          label: "תאריך לביצוע לפני",
          model: "dueDateBefore",
          active: true
        },
        {
          type: "BOOLEAN",
          label: "רק משימות שלא בוצעו",
          model: "notCompleted",
          active: true,
          expanded: true
        }
      ]
    };
  },
  computed: {
    tasks() {
      return this.$store.getters["entityList"]("tasks");
    },
    types() {
      return this.$store.getters["entityList"]("taskTypes");
    },
    resource() {
      return this.$store.state.resources["task"];
    },
    optionLists() {
      return {
        types: this.types
      };
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  },
  methods: {
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    },
    editTask(entity, isNew = false) {
      let resource = this.$store.state.resources.task;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    }
  },

  components: {
    AdvancedTable
  }
};
</script>